enum AppContext {
  Client,
  Server
}

export default AppContext;
